document.addEventListener('Searchanise.Loaded', function() {
  (function($) {
    var search_data;

    $(document).on('Searchanise.DataRequestEnd', function(event, type, params, data) {
      search_data = data.items;
    });

    $(document).on('Searchanise.ResultsUpdated', function() {
      for (var i = 0; i < search_data.length; i++) {
        var element = search_data[i];
        var productEl = $('#snize-product-' + element.product_id);
        
        if (productEl.length) {
          productEl[0].dataset.collectionsTitles = element.collections.split('[:ATTR:]').join(';');
        }

        if (!productEl.find('div[data-bv-show="rating_summary"]').length) {
          productEl.find('.snize-overhidden').append(
            '<div data-bv-show="rating_summary" data-bv-product-id="' + element.shopify_variants[0].sku + '"></div>'
          );
        }
      }
    });
  })(window.Searchanise.$);
});